/* =====================================================================
   GesCon · punto de entrada
   ---------------------------------------------------------------------
   Aquí solo se enchufan las piezas y se pinta por primera vez.
   Toda la lógica vive en los módulos que se importan.
   ===================================================================== */
import './estilos.css';

import { render } from './core/app.js';
import { conectarEventos } from './core/eventos.js';
import { conectarSubidaFicheros } from './features/ficheros.js';
import { conectarSubidaExcel } from './features/importar-precios.js';

conectarEventos();
conectarSubidaFicheros();
conectarSubidaExcel();
render();
